import { cn } from "@/lib/utils";

// Thin top-of-viewport progress bar shown while a checkout is being created.
// It ramps toward ~92% with an ease-out so it feels fast up front, then waits;
// the browser navigates to the Shopify checkout before it completes, so the bar
// is mid-flight when the new page takes over (the classic "loading" feel). On
// failure `active` flips back to false and it retracts.
export function CheckoutProgressBar({ active }: { active: boolean }) {
  return (
    <div
      aria-hidden
      className={cn(
        "pointer-events-none fixed inset-x-0 top-0 z-[100] h-[3px] transition-opacity duration-300",
        active ? "opacity-100" : "opacity-0",
      )}
    >
      <div
        className="h-full rounded-r-full bg-[hsl(var(--lb-clay))] shadow-[0_0_12px_hsl(var(--lb-clay)/0.7)] ease-out"
        style={{
          width: active ? "92%" : "0%",
          transitionProperty: "width",
          transitionDuration: active ? "9s" : "250ms",
        }}
      />
    </div>
  );
}
